import { render, staticRenderFns } from "./SinglePerson.vue?vue&type=template&id=3861e48c"
import script from "./SinglePerson.vue?vue&type=script&lang=js"
export * from "./SinglePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports